import React from "react";
import "./style.css";

const PrivacyPolicy = () => {
  return (
    <>
      {/* ---------- Banner Section ---------- */}
      <section className="privacy-banner">
        <div className="container">
          <h1 className="banner-title">Privacy Policy</h1>

          <div className="breadcrumb">
            <span>Home</span>
            <span className="arrow">→</span>
            <span>Privacy Policy</span>
          </div>
        </div>
      </section>

      {/* ---------- Content Section ---------- */}
      <section className="privacy-content-section">
        <div className="privacy-container">
          <h1 className="privacy-main-title">Privacy Policy</h1>

          <p>
            <strong>
              Omeswara is committed to safeguarding your personal information.
              Introduction to Privacy Policy
            </strong>
            <br />
            This privacy policy (the "PRIVACY POLICY") applies to your use of
            the OMESWARA FINTECH PRIVATE LIMITED (Refereed as Omeswara)
            website hosted at www.Omeswara.com, the Services (as defined in the
            Omeswara"Terms of Use"), and Omeswara applications on mobile
            platforms (Android, Blackberry, Windows Phone, iOS, etc.)
            (collectively "Omeswara" or "WEBSITE"), but does not apply to any
            third party websites linked to them. The terms "WE," "OUR," and "US"
            refer to Omeswara, while "YOU," "YOUR," and "USER" refer to you, as a
            Omeswara user. The term "PERSONAL INFORMATION" refers to information
            that you provide to us that allows you to be contacted or identified
            personally, such as your name, phone number, email address, and any
            other data that is linked to such information.
          </p>

          <p>
            Our practises and procedures for collecting and using Personal
            Information are outlined below in order to ensure your safe use of
            the Website. We have put in place reasonable security practices and
            procedures that are appropriate for the information assets we are
            protecting and the nature of our business. While we strive to
            provide security that exceeds industry standards, due to the
            inherent vulnerabilities of the internet, we cannot guarantee or
            warrant the complete security of all information transmitted to us
            by you.
          </p>

          <p>
            By visiting this Website, you agree and acknowledge that you are
            bound by this Privacy Policy and that we may collect, use, process,
            and share your Personal Information in the manner described below.
            Do not use the Website if you do not agree with these terms. It is
            clarified that the separate terms and conditions form an integral
            part of your use of this Website and should be read in conjunction
            with this Privacy Policy.
          </p>

          <h2 className="privacy-subtitle">Information Collected & Use</h2>

          <p>
  Your Personal Information is collected, received, and stored by us. If you provide us with your third-party account
  credentials ("THIRD PARTY ACCOUNT INFORMATION"), you acknowledge that some content and information in those accounts
  may be transmitted to your account with us if you authorise such transmissions, and that Third Party Account
  Information transmitted to us is covered by this Privacy Policy. You may choose not to provide us with certain
  information, but doing so will prevent you from registering with us or using some of our features and services.
  We make commercially reasonable efforts to limit the collection of Personal Information to that which is required to
  fulfil the purposes listed below. If we use or intend to use your information for a purpose other than the one for which
  it was collected, we will seek your permission first. The Personal Information collected will be used solely to enable
  you to use our services, to help promote a safe service, calibrate consumer interest in our products and services,
  inform you about online offers and updates, troubleshoot problems, customise User experience, detect and protect us
  against error, fraud, and other criminal activity, collect money, enforce our terms and conditions, and as otherwise
  described to you at the time of collection.
</p>

<h2 className="privacy-subtitle">What Information do we collect??</h2>

<p>
  We ask for and record Personal Information such as your name, email address, and mobile number when you create an
  account to take advantage of the full range of services offered by Omeswara. We may collect and store your Sensitive
  Personal Data or Information (such as any financial information, including credit card and debit card details, bank
  account and know your customer ("KYC") documents as per RBI regulations, and any other information as may be
  applicable) that the User may choose to save in the Omeswara User account. We use your email address to send you
  updates, news, and newsletters (if you choose to subscribe to the newsletter during signup or later) and to contact you
  on behalf of other Users (such other Users who send you friend requests, personal messages, or other social
  collaboration based events). If you do not want to receive communications from us that are not relevant to you or your
  use of our services, please click the unsubscribe link at the bottom of such e-mails. We use your mobile phone number
  to send you transaction and SMS alerts based on your preferences. If you do not want to receive such SMSs from us,
  please notify us and we will stop sending you SMSs.
</p>

<p>
  Omeswara guarantees that your Personal Information will not be made public or sold to third parties. Any information
  provided by the User, including Personal Information, shall be erased at the User's discretion. If a User chooses the
  erasure option, Omeswara will delete all of the User's stored information from its servers. We also keep records of
  customers who use Omeswara to make payments. However, only when a customer chooses to share information on businesses
  powered by Omeswara applications do we share that information with the respective businesses. However, Omeswara is not
  liable in any way for any misuse of this information by the business or people associated with the business to whom the
  customer shares the information.
</p>

<h2 className="privacy-subtitle">
  Your rights relating to the data we collect? You have the legal right to:
</h2>

<p>
  <strong>Keep up to date:</strong> We are required to provide ‘fair processing information’ on how your personal data
  will typically be used. This declaration is being used for this purpose.
</p>

<p>
  <strong>Access:</strong> You have the right to obtain confirmation as to whether personal data about you is being
  processed, where it is being processed, and for what purpose. This declaration is being used for this purpose.
</p>

<p>
  <strong>Rectification:</strong> If your personal data is inaccurate or incomplete, you have the right to have it
  corrected.
</p>

<p>
  <strong>Process Restrictions :</strong> Request that your personal information be deleted. 
  Stop further dissemination of the data and possibly have third parties stop processing the data.
</p>

<p>
  <strong>The portability of Data :</strong> You have the right to access and reuse their personal information. 
  It enables you to easily move, copy, or transfer your personal data from one IT environment to another in a safe 
  and secure manner, without interfering with usability.
</p>

<p>
  <strong>Object :</strong> You have the right to object to the use of your personally identifiable information 
  for direct marketing purposes.
</p>

<p>
  <strong>Profiling & Automated Deletion Marking :</strong> In our profiling activities, we use anonymized data.
</p>

<h2 className="privacy-subtitle">Feedback</h2>

<p>
  If you contact us to provide feedback, register a complaint, or ask a question, we will record any Personal 
  Information and other content you provide in your communication so that we can respond to your communication effectively.
</p>

<h2 className="privacy-subtitle">Activity</h2>

<p>
  We collect information about your Omeswara usage, such as the searches you conduct, the pages you view, your browser 
  type, IP address, location, requested URL, referring URL, and timestamp data. We use this information to administer 
  Omeswara and provide you with the highest level of security and service possible. We also use this information in 
  aggregate to perform statistical analyses of User behaviour and characteristics in order to gauge interest in and use 
  of Omeswara ’s various areas. This aggregate information, however, cannot be used to identify you.
</p>

<p>
  We own all intellectual property rights to the Website and its contents. As a result of any such downloading or 
  copying, no right, title, or interest in the downloaded material is transferred to you. According to applicable law, 
  the Website is protected by copyright as a collective work and/or compilation (meaning the collection, arrangement, 
  and assembly) of all the content on this Website. We own all of our logos, product and service marks and/or names, 
  trademarks, copyrights, and other intellectual property, whether registered or not ("OUR IP"). You agree not to 
  display or use Our IP in any way without our prior written permission. Without our express written permission, 
  nothing on this Website or its content should be construed as granting the User any license, right, or interest in 
  and/or to Our IP.
</p>

<h2 className="privacy-subtitle">Cookies</h2>

<p>
  Cookies are sent to your computer in order for us to uniquely identify your browser and improve the quality of our 
  service. Cookies are small pieces of information that a website sends to your computer’s hard drive while you are 
  browsing the site. We may use session cookies (which expire when you close your browser) as well as persistent cookies 
  (which stay on your computer until you delete them). Persistent cookies can be removed by following the instructions 
  in your browser’s help file. If you disable cookies, some parts of Omeswara may not function properly or at all.
</p>

<p>
  Omeswara employs third-party tools that may collect anonymous information about your Omeswara visits and interactions 
  with Omeswara products and services via cookies. These third parties may also use information about your visits to 
  Omeswara products and services as well as other websites to target advertisements for Omeswara products and services. 
  This process does not collect or use any personally identifiable information. These third parties do not know or have 
  access to Omeswara’s Users’ names, phone numbers, addresses, email addresses, or any other Personal Information. 
  Omeswara users can opt out of sharing this information with third parties by deactivating cookies, which varies by 
  browser. Please consult your browser’s help file to learn how to deactivate cookies on your browser.
</p>

<h2 className="privacy-subtitle">Enforcement</h2>

<p>
  We may use the information we collect as a result of your Omeswara use (including your Personal Information) to 
  investigate, enforce, and apply our terms and conditions and Privacy Policy.
</p>

<h2 className="privacy-subtitle">Transfer of information</h2>

<p>
  We do not share your Personal Information with any third party other than financial institutions such as banks, RBI, 
  or other regulatory agencies (as required) and to provide you with services offered by Omeswara, conduct quality 
  assurance testing, facilitate account creation, provide technical and customer support, or provide specific services, 
  such as synchronisation of your contacts with other software applications, in accordance with your instructions. 
  These third parties are not permitted to use your Personal Information for any purpose other than providing the 
  services you have requested.
</p>

<p>
  We may disclose your Personal Information to third parties if we believe in good faith that such disclosure is 
  reasonably necessary to (a) take action regarding suspected illegal activities; (b) enforce or apply our terms and 
  conditions and Privacy Policy; (c) comply with legal process, such as a search warrant, subpoena, statute, or court 
  order; or (d) protect our rights, reputation, and property, or the rights, reputation, and property of our Users, 
  Affiliates, or the public. Please keep in mind that we are under no obligation to question or contest the legality 
  of any search warrant, subpoena, or other similar governmental request that we receive. We may disclose aggregate 
  information about User behaviour to third parties in connection with actual or prospective business relationships 
  with those third parties, such as advertisers and content distributors. We may, for example, reveal the number of 
  Users who have been exposed to or clicked on advertising banners.
</p>

<h2 className="privacy-subtitle">Links</h2>

<p>
  Any references on this Website to third-party names, marks, products, or services, or hyperlinks to third-party 
  websites or information, are provided solely for your convenience and do not constitute or imply our endorsement, 
  sponsorship, or recommendation of the third-party, information, product, or service. We do not share your Personal 
  Information with those third parties, except as stated herein, and are not responsible for their privacy practises. 
  We recommend that you read the privacy policies on all third-party websites.
</p>

<h2 className="privacy-subtitle">Security</h2>

<h2 className="privacy-subtitle">Security</h2>

<p>
  Your password is the only way to access your account. We use industry-standard security measures to safeguard the 
  Personal Information stored in our database. We restrict access to your Personal Information to employees and 
  contractors who require it to perform their job functions, such as our customer service representatives. If you have 
  any questions about Omeswara’s security, please email us at You hereby acknowledge that Omeswara is not responsible for 
  any intercepted information sent via the internet, and you hereby release us from any and all claims arising out of or 
  related to the unauthorized use of intercepted information.
</p>

<h2 className="privacy-subtitle">Terms and modifications to this Privacy Policy</h2>

<p>
  Our Privacy Policy is subject to change without notice at any time. Please review this policy on a regular basis to 
  ensure you are aware of any changes. These changes will take effect immediately for Omeswara users. Please keep in mind 
  that you are always responsible for updating your Personal Information, including providing us with your most recent 
  e-mail address. If you do not want us to change how we use your Personal Information, you must notify us as soon as 
  possible that you want to deactivate your account with us. Continued use of Omeswara following any change/amendment to 
  this Privacy Policy indicates your acceptance of such changes and agreement to be bound by the terms and conditions of 
  such changes.
</p>

<h2 className="privacy-subtitle">Applicable Law</h2>

<p>
  The laws of India will govern and be construed in relation to your use of this Website. Users agree that any legal 
  action or proceedings arising out of their use will be brought solely in the competent courts/tribunals with 
  jurisdiction in Delhi, India, and irrevocably submit to the jurisdiction of such courts/tribunals.
</p>

<h2 className="privacy-subtitle">Complaints and Grievance Redressal</h2>

<p>
  Any complaints or concerns regarding your Personal Information or the content of this Website, or any dispute or 
  breach of confidentiality, or any proprietary rights of User during use of the Website, or any intellectual property of 
  any User, should be immediately reported in writing to our compliance email.
</p>

<h2 className="privacy-subtitle">OMESWARA FINTECH PRIVATE LIMITED</h2>

<p>
  <strong>Address:</strong> WARD 13 ATITHI VISRAM GRIH BAIRGANIA
City: SITAMARHI
State: Bihar
Pincode: 843313
</p>

<p>
  <strong>E-mail:</strong> omeswarafintech@gmail.com
</p>


        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
